export const BASE_URL = process.env.REACT_APP_API_BASE_URL


export const fetchApi = async ( url: string, options: {}, locale: string, query?: string ) =>
{
    console.log(BASE_URL)
    const response = await fetch( BASE_URL ? BASE_URL + `${ url }${ `?lang=${ locale }` }${ query ? `${ query }` : "" }` : "", options );
    const data = await response.json();
    return data;
}